module.exports = __webpack_public_path__ + "img/slider_a02_m.0cd9381.2e3e9ece.png";